import React from 'react';
import Table from 'react-bootstrap/Table';
import ActiviteProduit from '../../../../../common/src/entities/activite-produit.entity';
import { Activite } from '../../../../../common/src/entities';
import { useGetQuery } from '../../../Utils/api';

interface DynamicTableActiviteProps {
    data: ActiviteProduit[];
    title: string;
}

const DynamicTableActivite: React.FC<DynamicTableActiviteProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Max participants</th>
                        <th>Public ciblé</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => (
                        <tr key={row.id}>
                            <td>{row.activite.name}</td>
                            <td>{row.activite.max_participants !== null ? row.activite.max_participants : 'N/A'}</td>
                            <td>{row.activite.public_cible}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableActivite;
